import {Component, inject, Input} from '@angular/core';
import {EditSubscriptionPartner} from '../edit-subscription-partner/edit-subscription-partner';
import {RestClient} from '../../../../Api/DcoApi/Client/RestClient';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap/modal';
import {NgForOf} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

@Component({
  selector: 'app-subscription-authorization',
  imports: [
    EditSubscriptionPartner,
    NgForOf,
    ReactiveFormsModule,
    FormsModule
  ],
  templateUrl: './subscription-authorization.html',
  styleUrl: './subscription-authorization.css',
})
export class SubscriptionAuthorization {
  @Input() authModel: authorizationConfig = {} as authorizationConfig;
  @Input() isNew: boolean = false
  @Input() Id: string = ''
  Client: RestClient = new RestClient();
  modal = inject(NgbActiveModal);

  AuthType = [
    { key: 0, Bezeichnung: "None" },
    { key: 1, Bezeichnung: "BasicAuth" },
    { key: 2, Bezeichnung: "BearerToken" },
    { key: 3, Bezeichnung: "ApiKeyHeader" },
    { key: 4, Bezeichnung: "ApiKeyQuery" },
    { key: 5, Bezeichnung: "HmacSignature" },
    { key: 6, Bezeichnung: "OAuth2" },
    { key: 7, Bezeichnung: "ClientCertificate" },
  ]
  OAuthGrantType = [
    { key: null, Bezeichnung: "..." },
    { key: 0, Bezeichnung: "ClientCredentials" },
    { key: 1, Bezeichnung: "Password" },
    { key: 2, Bezeichnung: "RefreshToken" },
  ]

  async Save()
  {
    if(this.isNew)
    {
      var res = await this.Client.Post<any, authorizationConfig>(`/Backend/Api/V2/Admin/PushSubscription/${this.Id}/Auth`, this.authModel);
    }
    else
    {
      var res = await this.Client.Put<any, authorizationConfig>(`/Backend/Api/V2/Admin/PushSubscription/${this.Id}/Auth`, this.authModel);
    }
    this.modal.close();
  }

}


export interface authorizationConfig
{
  authType: number;
  username?: string;
  password?: string;
  token?: string;
  hmacSecret?: string;
  hmacHeaderName?: string;
  apiKeyName?: string;
  apiKeyValue?: string;
  oAuthGrantType?: number;
  oAuthTokenUrl?: string;
  oAuthClientId?: string;
  oAuthClientSecret?: string;
  oAuthScope?: string;
  oAuthUsername?: string;
  oAuthPassword?: string;
  oAuthRefreshToken?: string;
  clientCertificateThumbprint?: string;
  customHeaders: Record<string, string>;
}
